const customSelectStyles = (width = "auto", height = "auto") => ({
  container: (/** @type {any} */ provided) => ({
    ...provided,
    border: "1px solid #ccd0e7",
    borderRadius: "10px",
    boxShadow: "0px 2px 6px rgba(141, 155, 184, 0.25)",
    width: width,
    height: height,
  }),
  control: (/** @type {any} */ provided) => ({
    ...provided,
    border: "none",
    borderRadius: "10px",
    width: width,
    height: height,
  }),
  // More style definitions...
})

export default customSelectStyles
